import Store from '../Store';

const ProductStore = new Store('sourcing/products');

export {ProductStore};